import React, { memo } from 'react';
import { any } from 'prop-types';
import Radium from 'radium';

import UTForm from 'app/components/UTForm';

import styles from './styles.module.scss';

const PersonalInformation = ({ fields, fieldValues }) => (
  <UTForm
    fields={fields}
    fieldValues={fieldValues}
    replaceFieldNames
    formClasses={{ formContainer: styles.form, fieldRowContainer: styles.field }}
  />
);

PersonalInformation.propTypes = {
  fields: any, // eslint-disable-line react/forbid-prop-types
  fieldValues: any // eslint-disable-line react/forbid-prop-types
};

export default memo(Radium(PersonalInformation));
